/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
import React from 'react';
import { useLocation } from 'react-router-dom';
import _ from '../../../@lodash';
import clsx from 'clsx';
// BASE Components
import BASESvgIcon from '../../../@BASE/core/BASESvgIcon';
// material-ui
import Typography from '@mui/material/Typography';
import Hidden from '@mui/material/Hidden';
import IconButton from '@mui/material/IconButton';
// Custom Components
import SettingsNavigation from './SettingsNavigation';

function SettingsHeader(props) {
	const { className, onSetSidebarOpen } = props;
	const { pathname } = useLocation();
	const currentNavigation = _.find(SettingsNavigation.children, { url: pathname });

	return (
    <div className={clsx('flex space-x-12', className)}>
      <Hidden lgUp>
        <IconButton
          className="border border-divider"
          onClick={() => onSetSidebarOpen(true)}
          aria-label="open left sidebar"
        >
          <BASESvgIcon>heroicons-outline:bars-3</BASESvgIcon>
        </IconButton>
      </Hidden>
      <div>
        <Typography className=" text-3xl font-bold leading-none tracking-tight lg:ml-0">
        {currentNavigation?.title}
        </Typography>
      </div>
    </div>
	);
}

export default SettingsHeader;